import React, { useEffect, useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { GridColDef } from "@mui/x-data-grid";
import api from "../../../utils/Url";
import Card from "@mui/material/Card";
import {
    Box,
    Divider,
    Stack,
    Grid,
    Typography,
    TextField,
    Drawer,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
} from "@mui/material";
import { useFormik } from "formik";
import { format } from "date-fns";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import DataGrids from "../../../utils/Datagrids";
import ToastApp from "../../../ToastApp";
import { toast } from "react-toastify";
import CustomLabel from "../../../CustomLable";

// Redux imports
import { useDispatch, useSelector } from 'react-redux';
import { setFromDate, setToDate } from '../../../redux/dateSlice'; // import the actions from the slice
import { RootState } from "../../../redux/store"; // Import the RootState for types

export default function TrackingReportData() {
    const [zones, setZones] = useState<any[]>([]);
    const [columns, setColumns] = useState<GridColDef[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [swipModal, setSwipModal] = useState(false);
    const [swipData, setSwipData] = useState<any[]>([]);

    const { t } = useTranslation();
    
    // Get fromDate and toDate from Redux store
    const fromDate = useSelector((state: RootState) => state.date.fromDate);
    const toDate = useSelector((state: RootState) => state.date.toDate);

    // Redux dispatch
    const dispatch = useDispatch();

    // Set the initial values of formik based on Redux store
    const formik = useFormik({
        initialValues: {
            itemId: -1,
            poleNo: "",
            zoneid: -1,
            wardid: -1,
            empid: -1,
            fromDate: fromDate || format(new Date(), "yyyy-MM-dd"), // Default to Redux state or today's date
            toDate: toDate || format(new Date(), "yyyy-MM-dd"), // Default to Redux state or today's date
        },
        onSubmit: async (values) => {
            // You can handle form submission here if needed
        },
    });

    useEffect(() => {
        fetchZonesData();
    }, []);

    const fetchZonesData = async () => {
        try {
            const collectData = {
                id: -1,
            };
            const response = await api.post(`Trackerdata/Gettc_devices`, collectData);
            const data = response.data.data;

            const zonesWithIds = data.map((zone: any, index: number) => ({
                ...zone,
                serialNo: index + 1,
                id: zone.id,
            }));
            setZones(zonesWithIds);
            setIsLoading(false);

            if (data.length > 0) {
                const columns: GridColDef[] = [
                    {
                        field: "name",
                        headerName: t("text.Name"),
                        flex: 1,
                    },
                    {
                        field: "uniqueid",
                        headerName: t("text.UniqueId"),
                        flex: 1,
                        renderCell: (params) => (
                            <div
                                style={{ cursor: "pointer", color: "blue" }}
                                onClick={() => getModalData(params.row.id)}
                            >
                                {params.value}
                            </div>
                        ),
                    },
                    {
                        field: "lastupdate",
                        headerName: t("text.Lastupdate"),
                        flex: 1,
                        valueFormatter: (params) => {
                            const date = new Date(params.value);
                            return date ? format(date, "dd-MM-yyyy") : "__";
                        },
                    },
                    {
                        field: "positionid",
                        headerName: t("text.PositionId"),
                        flex: 1,
                    },
                    {
                        field: "status",
                        headerName: t("text.Status"),
                        flex: 1,
                    },
                ];
                setColumns(columns);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const getModalData = async (Id: any) => {
        // Check if fromDate and toDate are selected, if not show error
      
        // Debugging log to see the selected date values
        console.log("From Date:", fromDate);
        console.log("To Date:", toDate);

        const collectData = {
            id: -1,
            deviceid: Id,
            fromDate: fromDate, // The date in yyyy-MM-dd format
            toDate: toDate, // The date in yyyy-MM-dd format
        };

        try {
            const response = await api.post(`Trackerdata/Gettc_positions`, collectData);
            const data = response.data.data;
            setSwipData(data);
            setSwipModal(true);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    return (
        <>
            <Card style={{ width: "100%", backgroundColor: "lightgreen", marginTop: "3vh" }}>
                <Paper sx={{ width: "100%", overflow: "hidden" }} style={{ padding: "10px" }}>
                    <Grid item xs={12} container spacing={1}>
                        <Grid item lg={10} md={10} xs={12}>
                            <Typography gutterBottom variant="h5" sx={{ padding: "20px" }} align="left">
                                {t("text.TrackerData")}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Divider />

                    <Box height={10} />

                    <Grid item xs={12} container spacing={2} sx={{ marginTop: "1%" }}>
                        <Grid item sm={6} lg={6} xs={12}>
                            <TextField
                                label={<CustomLabel text={t("text.FromDate")} />}
                                value={formik.values.fromDate}
                                name="fromDate"
                                id="fromDate"
                                placeholder={t("text.FromDate")}
                                size="small"
                                fullWidth
                                type="date"
                                style={{ backgroundColor: "white" }}
                                onChange={(e) => {
                                    formik.handleChange(e);
                                    dispatch(setFromDate(e.target.value)); // Dispatch to Redux
                                }}
                                onBlur={formik.handleBlur}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item sm={6} lg={6} xs={12}>
                            <TextField
                                label={<CustomLabel text={t("text.ToDate")} />}
                                value={formik.values.toDate}
                                name="toDate"
                                id="toDate"
                                placeholder={t("text.ToDate")}
                                type="date"
                                size="small"
                                fullWidth
                                style={{ backgroundColor: "white" }}
                                onChange={(e) => {
                                    formik.handleChange(e);
                                    dispatch(setToDate(e.target.value)); // Dispatch to Redux
                                }}
                                onBlur={formik.handleBlur}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} container spacing={2} sx={{ marginTop: "1%" }}>
                        <Grid item sm={12} lg={12} xs={12}>
                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <CircularProgress />
                                </div>
                            ) : (
                                <DataGrids
                                    isLoading={isLoading}
                                    rows={zones}
                                    columns={columns}
                                    pageSizeOptions={[5, 10, 25, 50, 100]}
                                    initialPageSize={5}
                                />
                            )}
                        </Grid>

                        <Grid xs={12} lg={12} sm={12} item>
                            <Drawer anchor="right" style={{ zIndex: 1400 }} open={swipModal} onClose={() => setSwipModal(false)}>
                                <div style={{ width: "700px", padding: "20px", backgroundColor: "#f4f7fc" }}>
                                    <div
                                        style={{
                                            backgroundColor: "#1976D2", // Blue color for header
                                            color: "#fff",
                                            padding: "15px 20px",
                                            borderRadius: "8px 8px 0 0",
                                            textAlign: "center",
                                            fontSize: "18px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Tracker Data Position
                                    </div>

                                    <TableContainer style={{ marginTop: "20px" }}>
                                        <Table style={{ minWidth: 650 }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ backgroundColor: "#e3f2fd", fontWeight: "bold", color: "#1976D2", textAlign: "center" }}>
                                                        Protocol
                                                    </TableCell>
                                                    <TableCell style={{ backgroundColor: "#e3f2fd", fontWeight: "bold", color: "#1976D2", textAlign: "center" }}>
                                                        Server Time
                                                    </TableCell>
                                                    <TableCell style={{ backgroundColor: "#e3f2fd", fontWeight: "bold", color: "#1976D2", textAlign: "center" }}>
                                                        Device Time
                                                    </TableCell>
                                                    <TableCell style={{ backgroundColor: "#e3f2fd", fontWeight: "bold", color: "#1976D2", textAlign: "center" }}>
                                                        Fix Time
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {swipData.map((item: any) => (
                                                    <TableRow key={item.poleInstChildId}>
                                                        <TableCell style={{ textAlign: "left" }}>{item.protocol}</TableCell>
                                                        <TableCell style={{ textAlign: "right" }}>{item.servertime.slice(0, 10)}</TableCell>
                                                        <TableCell style={{ textAlign: "right" }}>{item.devicetime.slice(0, 10)}</TableCell>
                                                        <TableCell style={{ textAlign: "right" }}>{item.fixtime.slice(0, 10)}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </Drawer>
                        </Grid>
                    </Grid>
                </Paper>
            </Card>
            <ToastApp />
        </>
    );
}
